var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-items-center warp"},[(_vm.showBlock)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"warp-input",style:({width:_vm.width+"px"})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }